import axiosClient from '@/http/axiosClient'
import { GetAllNewsPayload, GetAllNewsResponse, GetNewsDetailResponse } from './type'


const NEWS_BASE_URL = process.env.NEXT_PUBLIC_NEWS_BASE_URL as string
const SITE_KEY = process.env.NEXT_PUBLIC_NEWS_SITE_KEY as string

console.log('NEWS_BASE_URL:', process.env.NEXT_PUBLIC_NEWS_BASE_URL)
console.log('SITE_KEY:', process.env.NEXT_PUBLIC_NEWS_SITE_KEY)

export const apiGetAllNews = (payload: GetAllNewsPayload) =>
    axiosClient
        .post<GetAllNewsResponse>(
            '/news/getAll',
            payload,
            {
                baseURL: NEWS_BASE_URL,
                withCredentials: false,
                headers: {
                    siteKey: SITE_KEY,
                },
            },
        )
        .then((res) => res.data)

export const apiGetNewsDetail = (newsIdOrGuid: number | string) =>
    axiosClient
        .get<GetNewsDetailResponse>(
            `/news/${newsIdOrGuid}`,
            {
                baseURL: NEWS_BASE_URL,
                withCredentials: false,
                headers: {
                    siteKey: SITE_KEY,
                },
            }
        )
        .then((res) => res.data)


